<template>
  <b-nav-item-dropdown
    ref="notificationDropdown"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
      <span v-if="unreadNotificationsCount > 0" class="badge badge-danger badge-up">{{ unreadNotificationsCount }}</span>
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <b-badge pill variant="light-primary"> New </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area h-300px"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link class="notification_hover" v-for="n in notifications" :key="n.id" @click="openNotification(n)">
        <div class="pl-1 pr-1">
          <p
            class="media-heading m-0 p-50 d-flex justify-content-between "
          >
            <span class="d-block">
              <feather-icon class="text-body active" v-if="n.is_read === false" icon="MailIcon" size="21" />
              <feather-icon class="text-body" v-else icon="InboxIcon" size="21" />
            </span>
            <span style="color: grey; padding-left: 10px;" class="font-weight-bolder" :class="n.is_read === false ? 'active':''">
              {{ n.title }}<br>
              {{ n.message }}<br>   
              <span style="font-size: 12px;">{{ n.created_at }}</span>           
            </span>
            
            <span class="d-block">
              <feather-icon :class="n.is_read === false ? 'active':''" class="text-body" icon="XCircleIcon" size="21" />
            </span>
          </p>
        </div>
        <hr class="my-0" />
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Footer -->
    <!-- <li class="pr-5 pl-5">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        block
      >
        See All Notifications
      </b-button>
    </li> -->
  </b-nav-item-dropdown>
</template>



<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  mixins: [util],
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    ToastificationContent,
  },
  data() {
    return {
      isRead: true,
      notifications: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      intervalId: null,
    };
  },
  directives: {
    Ripple,
  },
  computed: {
    ...mapGetters({}),
    unreadNotificationsCount() {
      return this.notifications.filter(n => n.is_read === false).length;
    },
  },
  async mounted() {
    await this.fetchNotifications();
  },
  methods: {
    ...mapActions({
      getNotifications: "appData/getNotifications",
      updateNotification: "appData/updateNotification",
    }),
    async openNotification(data){
      try {
        const formData = new FormData();
        formData.append("notification_type", data.notification_type);
        const res = await this.updateNotification({
          payload: formData,
          pk: data.id,
        });
        if (res.status === 200) {
            await this.fetchNotifications();
            this.$refs.notificationDropdown.hide();
            switch(data.notification_type) {
              case 'User':
                this.$router.push({ name: "User" });
                break;  
              case 'UserFlat':
                this.$router.push({ name: "FlatUsers" });
                break;  
              default:
                this.$router.push({ name: "Dashboard" });
            }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async fetchNotifications(){
      const notifications = await this.getNotifications();
      this.notifications = notifications.data;
    },
  },
};
</script>


<style scoped>
li {
  list-style-type: none;
}
.notification_hover :hover {
  background-color: #e8e8e9;
}
.active  {
  color: #febc03 !important;
}
.h-300px {
  height: 300px !important;
}
</style>